import '../../assets/index57.css';var dr = Object.defineProperty, fr = Object.defineProperties;
var mr = Object.getOwnPropertyDescriptors;
var _e = Object.getOwnPropertySymbols;
var Ue = Object.prototype.hasOwnProperty, je = Object.prototype.propertyIsEnumerable;
var Xe = (e, r, t) => r in e ? dr(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, f = (e, r) => {
  for (var t in r || (r = {}))
    Ue.call(r, t) && Xe(e, t, r[t]);
  if (_e)
    for (var t of _e(r))
      je.call(r, t) && Xe(e, t, r[t]);
  return e;
}, y = (e, r) => fr(e, mr(r));
var le = (e, r) => {
  var t = {};
  for (var n in e)
    Ue.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && _e)
    for (var n of _e(e))
      r.indexOf(n) < 0 && je.call(e, n) && (t[n] = e[n]);
  return t;
};
import { jsx as h, jsxs as ue } from "react/jsx-runtime";
import { forwardRef as Fe, useState as Me, createElement as hr, useRef as j, useEffect as Qe, useCallback as Pe } from "react";
import { Label as pr } from "../Label/index.js";
import { ErrorMessage as br } from "../../molecules/ErrorMessage/index.js";
import { r as qe } from "../../rem-CMQJ_ZTp.js";
import { e as Ge, c as Je } from "../../get-size-Bc1Pz5yf.js";
import { c as Ye } from "../../create-vars-resolver-Bzbn9G-G.js";
import { B as te, f as Ze, u as er, h as rr } from "../../factory-ueRxoNOV.js";
import { u as tr } from "../../use-styles-DToiHEa6.js";
import { u as ar } from "../../DirectionProvider-CT8S13Cp.js";
import { c as vr } from "../../create-safe-context-DqDyoPVE.js";
import { T as kr } from "../../Transition-esp-rpzm.js";
import { u as nr } from "../../use-uncontrolled-BT_j5D2R.js";
import { u as or } from "../../use-move-d_9eZhab.js";
import { u as sr } from "../../use-merged-ref-n551Tfbr.js";
import { c as Ae } from "../../clamp-CqQfNxSP.js";
function Ne(e, r) {
  return r.length === 0 ? e : r.reduce(
    (t, n) => Math.abs(n - e) < Math.abs(t - e) ? n : t
  );
}
const [lr, xe] = vr(
  "SliderProvider was not found in tree"
), Oe = Fe(
  (C, m) => {
    var o = C, { size: e, disabled: r, variant: t, color: n, thumbSize: i, radius: d } = o, V = le(o, ["size", "disabled", "variant", "color", "thumbSize", "radius"]);
    const { getStyles: l } = xe();
    return /* @__PURE__ */ h(
      te,
      f(f({
        tabIndex: -1,
        variant: t,
        size: e,
        ref: m
      }, l("root")), V)
    );
  }
);
Oe.displayName = "@mantine/core/SliderRoot";
const ge = Fe(
  ({
    max: e,
    min: r,
    value: t,
    position: n,
    label: i,
    dragging: d,
    onMouseDown: V,
    onKeyDownCapture: m,
    labelTransitionProps: C,
    labelAlwaysOn: o,
    thumbLabel: l,
    onFocus: v,
    onBlur: L,
    showLabelOnHover: w,
    isHovered: F,
    children: c = null,
    disabled: K
  }, M) => {
    const { getStyles: N } = xe(), [ce, B] = Me(!1), ie = o || d || ce || w && F;
    return /* @__PURE__ */ ue(
      te,
      y(f({
        tabIndex: 0,
        role: "slider",
        "aria-label": l,
        "aria-valuemax": e,
        "aria-valuemin": r,
        "aria-valuenow": t,
        ref: M,
        __vars: { "--slider-thumb-offset": `${n}%` }
      }, N("thumb", { focusable: !0 })), {
        mod: { dragging: d, disabled: K },
        onFocus: (_) => {
          B(!0), typeof v == "function" && v(_);
        },
        onBlur: (_) => {
          B(!1), typeof L == "function" && L(_);
        },
        onTouchStart: V,
        onMouseDown: V,
        onKeyDownCapture: m,
        onClick: (_) => _.stopPropagation(),
        children: [
          c,
          /* @__PURE__ */ h(
            kr,
            y(f({
              mounted: i != null && !!ie,
              transition: "fade",
              duration: 0
            }, C), {
              children: (_) => /* @__PURE__ */ h("div", y(f({}, N("label", { style: _ })), { children: i }))
            })
          )
        ]
      })
    );
  }
);
ge.displayName = "@mantine/core/SliderThumb";
function ye({ value: e, min: r, max: t }) {
  const n = (e - r) / (t - r) * 100;
  return Math.min(Math.max(n, 0), 100);
}
function _r({ mark: e, offset: r, value: t, inverted: n = !1 }) {
  return n ? typeof r == "number" && e.value <= r || e.value >= t : typeof r == "number" ? e.value >= r && e.value <= t : e.value <= t;
}
function ur({ marks: e, min: r, max: t, disabled: n, value: i, offset: d, inverted: V }) {
  const { getStyles: m } = xe();
  if (!e)
    return null;
  const C = e.map((o, l) => /* @__PURE__ */ hr(
    te,
    y(f({}, m("markWrapper")), {
      __vars: { "--mark-offset": `${ye({ value: o.value, min: r, max: t })}%` },
      key: l
    }),
    /* @__PURE__ */ h(
      te,
      y(f({}, m("mark")), {
        mod: { filled: _r({ mark: o, value: i, offset: d, inverted: V }), disabled: n }
      })
    ),
    o.label && /* @__PURE__ */ h("div", y(f({}, m("markLabel")), { children: o.label }))
  ));
  return /* @__PURE__ */ h("div", { children: C });
}
ur.displayName = "@mantine/core/SliderMarks";
function Ie(C) {
  var o = C, {
    filled: e,
    children: r,
    offset: t,
    disabled: n,
    marksOffset: i,
    inverted: d,
    containerProps: V
  } = o, m = le(o, [
    "filled",
    "children",
    "offset",
    "disabled",
    "marksOffset",
    "inverted",
    "containerProps"
  ]);
  const { getStyles: l } = xe();
  return /* @__PURE__ */ h(te, y(f(y(f({}, l("trackContainer")), { mod: { disabled: n } }), V), { children: /* @__PURE__ */ ue(te, y(f({}, l("track")), { mod: { inverted: d, disabled: n }, children: [
    /* @__PURE__ */ h(
      te,
      f({
        mod: { inverted: d, disabled: n },
        __vars: {
          "--slider-bar-width": `calc(${e}% + var(--slider-size))`,
          "--slider-bar-offset": `calc(${t}% - var(--slider-size))`
        }
      }, l("bar"))
    ),
    r,
    /* @__PURE__ */ h(ur, y(f({}, m), { offset: i, disabled: n, inverted: d }))
  ] })) }));
}
Ie.displayName = "@mantine/core/SliderTrack";
function Ee({
  value: e,
  containerWidth: r,
  min: t,
  max: n,
  step: i,
  precision: d
}) {
  const m = (r ? Math.min(Math.max(e, 0), r) / r : e) * (n - t), C = (m !== 0 ? Math.round(m / i) * i : 0) + t, o = Math.max(C, t);
  return d !== void 0 ? Number(o.toFixed(d)) : o;
}
function A(e, r) {
  return parseFloat(e.toFixed(r));
}
function cr(e) {
  if (!e)
    return 0;
  const r = e.toString().split(".");
  return r.length > 1 ? r[1].length : 0;
}
function ee(e, r) {
  const n = [...r].sort((i, d) => i.value - d.value).find((i) => i.value > e);
  return n ? n.value : e;
}
function re(e, r) {
  const n = [...r].sort((i, d) => d.value - i.value).find((i) => i.value < e);
  return n ? n.value : e;
}
function ze(e) {
  const r = [...e].sort((t, n) => t.value - n.value);
  return r.length > 0 ? r[0].value : 0;
}
function He(e) {
  const r = [...e].sort((t, n) => t.value - n.value);
  return r.length > 0 ? r[r.length - 1].value : 100;
}
var Se = { root: "m_dd36362e", label: "m_c9357328", thumb: "m_c9a9a60a", trackContainer: "m_a8645c2", track: "m_c9ade57f", bar: "m_38aeed47", markWrapper: "m_b7b0423a", mark: "m_dd33bc19", markLabel: "m_68c77a5b" };
const Mr = {
  radius: "xl",
  min: 0,
  max: 100,
  step: 1,
  marks: [],
  label: (e) => e,
  labelTransitionProps: { transition: "fade", duration: 0 },
  labelAlwaysOn: !1,
  thumbLabel: "",
  showLabelOnHover: !0,
  disabled: !1,
  scale: (e) => e
}, gr = Ye(
  (e, { size: r, color: t, thumbSize: n, radius: i }) => ({
    root: {
      "--slider-size": Je(r, "slider-size"),
      "--slider-color": t ? rr(t, e) : void 0,
      "--slider-radius": i === void 0 ? void 0 : Ge(i),
      "--slider-thumb-size": n !== void 0 ? qe(n) : "calc(var(--slider-size) * 2)"
    }
  })
), $e = Ze((e, r) => {
  const t = er("Slider", Mr, e), oe = t, {
    classNames: n,
    styles: i,
    value: d,
    onChange: V,
    onChangeEnd: m,
    size: C,
    min: o,
    max: l,
    step: v,
    precision: L,
    defaultValue: w,
    name: F,
    marks: c,
    label: K,
    labelTransitionProps: M,
    labelAlwaysOn: N,
    thumbLabel: ce,
    showLabelOnHover: B,
    thumbChildren: ie,
    disabled: _,
    unstyled: ae,
    scale: Q,
    inverted: $,
    className: we,
    style: ne,
    vars: Ve,
    hiddenInputProps: Ce,
    restrictToMarks: D,
    thumbProps: Re
  } = oe, pe = le(oe, [
    "classNames",
    "styles",
    "value",
    "onChange",
    "onChangeEnd",
    "size",
    "min",
    "max",
    "step",
    "precision",
    "defaultValue",
    "name",
    "marks",
    "label",
    "labelTransitionProps",
    "labelAlwaysOn",
    "thumbLabel",
    "showLabelOnHover",
    "thumbChildren",
    "disabled",
    "unstyled",
    "scale",
    "inverted",
    "className",
    "style",
    "vars",
    "hiddenInputProps",
    "restrictToMarks",
    "thumbProps"
  ]), q = tr({
    name: "Slider",
    props: t,
    classes: Se,
    classNames: n,
    className: we,
    styles: i,
    style: ne,
    vars: Ve,
    varsResolver: gr,
    unstyled: ae
  }), { dir: P } = ar(), [Te, be] = Me(!1), [p, x] = nr({
    value: typeof d == "number" ? Ae(d, o, l) : d,
    defaultValue: typeof w == "number" ? Ae(w, o, l) : w,
    finalValue: Ae(0, o, l),
    onChange: V
  }), X = j(p), U = j(m);
  Qe(() => {
    U.current = m;
  }, [m]);
  const de = j(null), k = j(null), ve = ye({ value: p, min: o, max: l }), b = Q(p), O = typeof K == "function" ? K(b) : K, W = L != null ? L : cr(v), G = Pe(
    ({ x: g }) => {
      if (!_) {
        const z = Ee({
          value: g,
          min: o,
          max: l,
          step: v,
          precision: W
        });
        x(
          D && (c != null && c.length) ? Ne(
            z,
            c.map((Y) => Y.value)
          ) : z
        ), X.current = z;
      }
    },
    [_, o, l, v, W, x, c, D]
  ), J = Pe(() => {
    if (!_ && U.current) {
      const g = D && (c != null && c.length) ? Ne(
        X.current,
        c.map((z) => z.value)
      ) : X.current;
      U.current(g);
    }
  }, [_, c, D]), { ref: E, active: Le } = or(G, { onScrubEnd: J }, P), S = Pe(
    (g) => {
      !_ && U.current && U.current(g);
    },
    [_]
  ), De = (g) => {
    var z, Y, Z, ke, fe, me;
    if (!_)
      switch (g.key) {
        case "ArrowUp": {
          if (g.preventDefault(), (z = k.current) == null || z.focus(), D && c) {
            const a = ee(p, c);
            x(a), S(a);
            break;
          }
          const R = A(
            Math.min(Math.max(p + v, o), l),
            W
          );
          x(R), S(R);
          break;
        }
        case "ArrowRight": {
          if (g.preventDefault(), (Y = k.current) == null || Y.focus(), D && c) {
            const a = P === "rtl" ? re(p, c) : ee(p, c);
            x(a), S(a);
            break;
          }
          const R = A(
            Math.min(Math.max(P === "rtl" ? p - v : p + v, o), l),
            W
          );
          x(R), S(R);
          break;
        }
        case "ArrowDown": {
          if (g.preventDefault(), (Z = k.current) == null || Z.focus(), D && c) {
            const a = re(p, c);
            x(a), S(a);
            break;
          }
          const R = A(
            Math.min(Math.max(p - v, o), l),
            W
          );
          x(R), S(R);
          break;
        }
        case "ArrowLeft": {
          if (g.preventDefault(), (ke = k.current) == null || ke.focus(), D && c) {
            const a = P === "rtl" ? ee(p, c) : re(p, c);
            x(a), S(a);
            break;
          }
          const R = A(
            Math.min(Math.max(P === "rtl" ? p + v : p - v, o), l),
            W
          );
          x(R), S(R);
          break;
        }
        case "Home": {
          if (g.preventDefault(), (fe = k.current) == null || fe.focus(), D && c) {
            x(ze(c)), S(ze(c));
            break;
          }
          x(o), S(o);
          break;
        }
        case "End": {
          if (g.preventDefault(), (me = k.current) == null || me.focus(), D && c) {
            x(He(c)), S(He(c));
            break;
          }
          x(l), S(l);
          break;
        }
      }
  };
  return /* @__PURE__ */ h(lr, { value: { getStyles: q }, children: /* @__PURE__ */ ue(
    Oe,
    y(f({}, pe), {
      ref: sr(r, de),
      onKeyDownCapture: De,
      onMouseDownCapture: () => {
        var g;
        return (g = de.current) == null ? void 0 : g.focus();
      },
      size: C,
      disabled: _,
      children: [
        /* @__PURE__ */ h(
          Ie,
          {
            inverted: $,
            offset: 0,
            filled: ve,
            marks: c,
            min: o,
            max: l,
            value: b,
            disabled: _,
            containerProps: {
              ref: E,
              onMouseEnter: B ? () => be(!0) : void 0,
              onMouseLeave: B ? () => be(!1) : void 0
            },
            children: /* @__PURE__ */ h(
              ge,
              y(f({
                max: l,
                min: o,
                value: b,
                position: ve,
                dragging: Le,
                label: O,
                ref: k,
                labelTransitionProps: M,
                labelAlwaysOn: N,
                thumbLabel: ce,
                showLabelOnHover: B,
                isHovered: Te,
                disabled: _
              }, Re), {
                children: ie
              })
            )
          }
        ),
        /* @__PURE__ */ h("input", f({ type: "hidden", name: F, value: b }, Ce))
      ]
    })
  ) });
});
$e.classes = Se;
$e.displayName = "@mantine/core/Slider";
function yr(e) {
  return "TouchEvent" in window && e instanceof window.TouchEvent ? e.touches[0].clientX : e.clientX;
}
const xr = Ye(
  (e, { size: r, color: t, thumbSize: n, radius: i }) => ({
    root: {
      "--slider-size": Je(r, "slider-size"),
      "--slider-color": t ? rr(t, e) : void 0,
      "--slider-radius": i === void 0 ? void 0 : Ge(i),
      "--slider-thumb-size": n !== void 0 ? qe(n) : "calc(var(--slider-size) * 2)"
    }
  })
), Sr = {
  min: 0,
  max: 100,
  minRange: 10,
  step: 1,
  marks: [],
  label: (e) => e,
  labelTransitionProps: { transition: "fade", duration: 0 },
  labelAlwaysOn: !1,
  showLabelOnHover: !0,
  disabled: !1,
  scale: (e) => e
}, We = Ze((e, r) => {
  const t = er("RangeSlider", Sr, e), R = t, {
    classNames: n,
    styles: i,
    value: d,
    onChange: V,
    onChangeEnd: m,
    size: C,
    min: o,
    max: l,
    minRange: v,
    maxRange: L,
    step: w,
    precision: F,
    defaultValue: c,
    name: K,
    marks: M,
    label: N,
    labelTransitionProps: ce,
    labelAlwaysOn: B,
    thumbFromLabel: ie,
    thumbToLabel: _,
    showLabelOnHover: ae,
    thumbChildren: Q,
    disabled: $,
    unstyled: we,
    scale: ne,
    inverted: Ve,
    className: Ce,
    style: D,
    vars: Re,
    hiddenInputProps: pe,
    restrictToMarks: q,
    thumbProps: P
  } = R, Te = le(R, [
    "classNames",
    "styles",
    "value",
    "onChange",
    "onChangeEnd",
    "size",
    "min",
    "max",
    "minRange",
    "maxRange",
    "step",
    "precision",
    "defaultValue",
    "name",
    "marks",
    "label",
    "labelTransitionProps",
    "labelAlwaysOn",
    "thumbFromLabel",
    "thumbToLabel",
    "showLabelOnHover",
    "thumbChildren",
    "disabled",
    "unstyled",
    "scale",
    "inverted",
    "className",
    "style",
    "vars",
    "hiddenInputProps",
    "restrictToMarks",
    "thumbProps"
  ]), be = tr({
    name: "Slider",
    props: t,
    classes: Se,
    classNames: n,
    className: Ce,
    styles: i,
    style: D,
    vars: Re,
    varsResolver: xr,
    unstyled: we
  }), { dir: p } = ar(), [x, X] = Me(-1), [U, de] = Me(!1), [k, ve] = nr({
    value: d,
    defaultValue: c,
    finalValue: [o, l],
    onChange: V
  }), b = j(k), O = j([]), W = j(null), G = j(void 0), J = [
    ye({ value: k[0], min: o, max: l }),
    ye({ value: k[1], min: o, max: l })
  ], E = F != null ? F : cr(w), Le = (a) => {
    ve(a), b.current = a;
  };
  Qe(
    () => {
      Array.isArray(d) && (b.current = d);
    },
    Array.isArray(d) ? [d[0], d[1]] : [null, null]
  );
  const S = (a, s, T) => {
    if (s === -1)
      return;
    const u = [...b.current];
    if (q && M) {
      const H = Ne(
        a,
        M.map((ir) => ir.value)
      ), he = u[s];
      u[s] = H;
      const se = s === 0 ? 1 : 0, Ke = He(M), Be = ze(M);
      H === Ke && u[se] === Ke || H === Be && u[se] === Be ? u[s] = he : H === u[se] && (he > u[se] ? u[se] = re(H, M) : u[se] = ee(H, M));
    } else
      u[s] = a, s === 0 && (a > u[1] - (v - 1e-9) && (u[1] = Math.min(a + v, l)), a > (l - (v - 1e-9) || o) && (u[s] = b.current[s]), u[1] - a > L && (u[1] = a + L)), s === 1 && (a < u[0] + v && (u[0] = Math.max(a - v, o)), a < u[0] + v && (u[s] = b.current[s]), a - u[0] > L && (u[0] = a - L));
    if (u[0] = A(u[0], E), u[1] = A(u[1], E), u[0] > u[1]) {
      const H = u[0];
      u[0] = u[1], u[1] = H;
    }
    Le(u), T && (m == null || m(b.current));
  }, De = (a) => {
    if (!$) {
      const s = Ee({
        value: a,
        min: o,
        max: l,
        step: w,
        precision: E
      });
      S(s, G.current, !1);
    }
  }, { ref: oe, active: g } = or(
    ({ x: a }) => De(a),
    { onScrubEnd: () => !$ && (m == null ? void 0 : m(b.current)) },
    p
  );
  function z(a) {
    G.current = a;
  }
  const Y = (a) => {
    oe.current.focus();
    const s = oe.current.getBoundingClientRect(), T = yr(a.nativeEvent), u = Ee({
      value: T - s.left,
      max: l,
      min: o,
      step: w,
      containerWidth: s.width
    }), H = Math.abs(k[0] - u) > Math.abs(k[1] - u) ? 1 : 0, he = p === "ltr" ? H : H === 1 ? 0 : 1;
    G.current = he;
  }, Z = () => x !== 1 && x !== 0 ? (X(0), 0) : x, ke = (a) => {
    if (!$)
      switch (a.key) {
        case "ArrowUp": {
          a.preventDefault();
          const s = Z();
          O.current[s].focus();
          const T = q && M ? ee(b.current[s], M) : Math.min(Math.max(b.current[s] + w, o), l);
          S(A(T, E), s, !0);
          break;
        }
        case "ArrowRight": {
          a.preventDefault();
          const s = Z();
          O.current[s].focus();
          const T = q && M ? (p === "rtl" ? re : ee)(
            b.current[s],
            M
          ) : Math.min(
            Math.max(
              p === "rtl" ? b.current[s] - w : b.current[s] + w,
              o
            ),
            l
          );
          S(A(T, E), s, !0);
          break;
        }
        case "ArrowDown": {
          a.preventDefault();
          const s = Z();
          O.current[s].focus();
          const T = q && M ? re(b.current[s], M) : Math.min(Math.max(b.current[s] - w, o), l);
          S(A(T, E), s, !0);
          break;
        }
        case "ArrowLeft": {
          a.preventDefault();
          const s = Z();
          O.current[s].focus();
          const T = q && M ? (p === "rtl" ? ee : re)(
            b.current[s],
            M
          ) : Math.min(
            Math.max(
              p === "rtl" ? b.current[s] + w : b.current[s] - w,
              o
            ),
            l
          );
          S(A(T, E), s, !0);
          break;
        }
      }
  }, fe = {
    max: l,
    min: o,
    size: C,
    labelTransitionProps: ce,
    labelAlwaysOn: B,
    onBlur: () => X(-1)
  }, me = Array.isArray(Q);
  return /* @__PURE__ */ h(lr, { value: { getStyles: be }, children: /* @__PURE__ */ ue(
    Oe,
    y(f({}, Te), {
      size: C,
      ref: sr(r, W),
      disabled: $,
      onMouseDownCapture: () => {
        var a;
        return (a = W.current) == null ? void 0 : a.focus();
      },
      onKeyDownCapture: () => {
        var a, s, T;
        (s = (a = O.current[0]) == null ? void 0 : a.parentElement) != null && s.contains(document.activeElement) || (T = O.current[0]) == null || T.focus();
      },
      children: [
        /* @__PURE__ */ ue(
          Ie,
          {
            offset: J[0],
            marksOffset: k[0],
            filled: J[1] - J[0],
            marks: M,
            inverted: Ve,
            min: o,
            max: l,
            value: k[1],
            disabled: $,
            containerProps: {
              ref: oe,
              onMouseEnter: ae ? () => de(!0) : void 0,
              onMouseLeave: ae ? () => de(!1) : void 0,
              onTouchStartCapture: Y,
              onTouchEndCapture: () => {
                G.current = -1;
              },
              onMouseDownCapture: Y,
              onMouseUpCapture: () => {
                G.current = -1;
              },
              onKeyDownCapture: ke
            },
            children: [
              /* @__PURE__ */ h(
                ge,
                y(f(y(f({}, fe), {
                  value: ne(k[0]),
                  position: J[0],
                  dragging: g,
                  label: typeof N == "function" ? N(A(ne(k[0]), E)) : N,
                  ref: (a) => {
                    O.current[0] = a;
                  },
                  thumbLabel: ie,
                  onMouseDown: () => z(0),
                  onFocus: () => X(0),
                  showLabelOnHover: ae,
                  isHovered: U,
                  disabled: $
                }), P == null ? void 0 : P(0)), {
                  children: me ? Q[0] : Q
                })
              ),
              /* @__PURE__ */ h(
                ge,
                y(f(y(f({}, fe), {
                  thumbLabel: _,
                  value: ne(k[1]),
                  position: J[1],
                  dragging: g,
                  label: typeof N == "function" ? N(A(ne(k[1]), E)) : N,
                  ref: (a) => {
                    O.current[1] = a;
                  },
                  onMouseDown: () => z(1),
                  onFocus: () => X(1),
                  showLabelOnHover: ae,
                  isHovered: U,
                  disabled: $
                }), P == null ? void 0 : P(1)), {
                  children: me ? Q[1] : Q
                })
              )
            ]
          }
        ),
        /* @__PURE__ */ h("input", f({ type: "hidden", name: `${K}_from`, value: k[0] }, pe)),
        /* @__PURE__ */ h("input", f({ type: "hidden", name: `${K}_to`, value: k[1] }, pe))
      ]
    })
  ) });
});
We.classes = Se;
We.displayName = "@mantine/core/RangeSlider";
const wr = "Slider-module__root___djxWK", Vr = "Slider-module__sliderRoot___XxQQ4", Cr = "Slider-module__track___pPu5n", Rr = "Slider-module__bar___gSXlV", Tr = "Slider-module__thumb___4HkOs", Lr = "Slider-module__markWrapper___B9rrL", Dr = "Slider-module__mark___3806X", Pr = "Slider-module__markLabel___ebzO-", Ar = "Slider-module__description___w3pD3", I = {
  root: wr,
  sliderRoot: Vr,
  track: Cr,
  bar: Rr,
  thumb: Tr,
  markWrapper: Lr,
  mark: Dr,
  markLabel: Pr,
  description: Ar
}, Nr = Fe(
  (w, L) => {
    var F = w, {
      label: e,
      description: r,
      error: t,
      className: n,
      "data-plum-id": i,
      min: d = 0,
      max: V = 100,
      range: m = !1,
      rangeValue: C,
      rangeDefaultValue: o,
      onRangeChange: l
    } = F, v = le(F, [
      "label",
      "description",
      "error",
      "className",
      "data-plum-id",
      "min",
      "max",
      "range",
      "rangeValue",
      "rangeDefaultValue",
      "onRangeChange"
    ]);
    const c = {
      ref: L,
      min: d,
      max: V,
      classNames: {
        root: I.sliderRoot,
        track: I.track,
        bar: I.bar,
        thumb: I.thumb,
        trackContainer: I.trackContainer,
        markWrapper: I.markWrapper,
        mark: I.mark,
        markLabel: I.markLabel
      }
    };
    return /* @__PURE__ */ ue("div", { className: I.root, "data-plum-id": i, children: [
      e && /* @__PURE__ */ h(pr, { label: typeof e == "string" ? e : String(e) }),
      m ? /* @__PURE__ */ h(
        We,
        y(f({}, c), {
          value: C,
          defaultValue: o,
          onChange: l
        })
      ) : /* @__PURE__ */ h($e, f(f({}, c), v)),
      r && /* @__PURE__ */ h("p", { className: I.description, children: r }),
      t && /* @__PURE__ */ h(br, { error: t })
    ] });
  }
);
Nr.displayName = "Slider";
export {
  Nr as Slider
};
